"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDrawData = void 0;
function getDrawData(_a) {
    var _b = _a.imageObj, avatarUrl = _b.avatarUrl, projectPicUrl = _b.projectPicUrl, QRUrl = _b.QRUrl, _c = _a.textObj, nickName = _c.nickName, projectName = _c.projectName, showName = _c.showName, shopName = _c.shopName, ticketInfoText = _c.ticketInfoText;
    return {
        width: 750,
        height: 1500,
        imgArr: [
            // 背景图
            {
                drawType: 'image',
                url: 'https://p0.pipi.cn/mediaplus/fe_rock_web/0fa33452f87ea4bf8825cbe997612f8478e2e.png?imageMogr2/thumbnail/2500x2500%3E',
                x: 0,
                y: 0,
                width: 750,
                height: 1500,
                zIndex: 2,
                id: 2,
            },
            // 头像
            {
                drawType: 'image',
                url: avatarUrl || 'https://p0.meituan.net/scarlett/2b130486b1c209d988544b9a5cc454ff4719.png',
                x: 34,
                y: 30,
                zIndex: 3,
                backgroundColor: '#fff',
                borderRadius: 50,
                id: 3,
                width: 100,
                height: 100,
            },
            // 详情信息背景图
            {
                drawType: 'image',
                url: 'https://p0.pipi.cn/mediaplus/fe_rock_web/0fa33452f87ea4494825ce2cb76f5c01e6b25.png?imageMogr2/thumbnail/2500x2500%3E',
                x: 26,
                y: 150,
                width: 702,
                height: 428,
                zIndex: 6,
                id: 6,
            },
            // 详情商品图
            {
                drawType: 'image',
                url: projectPicUrl,
                x: 44,
                y: 170,
                width: 280,
                height: 388,
                zIndex: 7,
                id: 7,
                borderRadius: 16,
            },
            // 动效静态图
            {
                drawType: 'image',
                url: 'https://p0.pipi.cn/mediaplus/fe_rock_web/0fa334fc80115de327c8bee1b386c21f5887c.png?imageMogr2/thumbnail/2500x2500%3E',
                x: 25,
                y: 550,
                width: 700,
                height: 800,
                zIndex: 15,
                id: 15,
            },
            // 二维码底部背景
            {
                drawType: 'image',
                url: 'https://p0.pipi.cn/mediaplus/fe_rock_web/0fa334fc801e328b077f0721969ea6e4a06b6.png?imageMogr2/thumbnail/2500x2500%3E',
                x: 0,
                y: 1320,
                width: 750,
                height: 180,
                zIndex: 16,
                id: 16,
            },
            // 二维码图片
            {
                drawType: 'image',
                url: QRUrl,
                x: 576,
                y: 1334,
                width: 154,
                height: 154,
                zIndex: 17,
                borderRadius: 12,
                id: 17,
            },
        ],
        rectArr: [
            {
                drawType: 'rect',
                x: 0,
                y: -2,
                height: 1500,
                width: 750,
                zIndex: 1,
                id: 1,
            },
        ],
        avatarArr: [],
        textArr: [
            {
                drawType: 'text',
                x: 150,
                y: 56,
                zIndex: 3,
                color: '#4A1212',
                text: nickName,
                fontSize: 32,
                textAlign: 'left',
                fontFamily: 'PingFangSC-Semibold',
                letterSpacing: 0,
                lineHeight: 36,
                fontWeight: 600,
                id: 4,
                width: 26,
                height: 36,
            },
            {
                drawType: 'text',
                x: 150,
                y: 100,
                zIndex: 5,
                color: 'rgba(74,18,18,0.60)',
                text: '丝滑抢票上猫眼！',
                fontSize: 24,
                textAlign: 'left',
                id: 5,
                width: 104,
                height: 24,
            },
            {
                drawType: 'text',
                x: 360,
                y: 190,
                zIndex: 8,
                color: '#2E1919',
                text: projectName,
                fontSize: 30,
                textAlign: 'left',
                lineHeight: 40,
                fontFamily: 'PingFangSC-Semibold',
                letterSpacing: 0,
                fontWeight: 600,
                containerWidth: 340,
                id: 8,
                row: 3,
                width: 548.0538330078125,
                height: 40,
            },
            {
                drawType: 'text',
                x: 360,
                y: 326,
                zIndex: 9,
                text: '场次',
                fontSize: 24,
                fontFamily: 'PingFangSC-Regular',
                color: '#999999',
                'letter-spacing': 0,
                lineHeight: 24,
                'font-weight': 400,
                textAlign: 'left',
                id: 9,
                width: 26,
                height: 24,
            },
            {
                drawType: 'text',
                x: 360,
                y: 418,
                zIndex: 9,
                text: '场馆',
                fontSize: 24,
                fontFamily: 'PingFangSC-Regular',
                color: '#999999',
                'letter-spacing': 0,
                lineHeight: 24,
                'font-weight': 400,
                textAlign: 'left',
                id: 9,
                width: 26,
                height: 24,
            },
            {
                drawType: 'text',
                x: 360,
                y: 510,
                zIndex: 9,
                text: '票档',
                fontSize: 24,
                fontFamily: 'PingFangSC-Regular',
                color: '#999999',
                'letter-spacing': 0,
                lineHeight: 24,
                'font-weight': 400,
                textAlign: 'left',
                id: 9,
                width: 26,
                height: 24,
            },
            {
                drawType: 'text',
                x: 360,
                y: 454,
                zIndex: 10,
                color: '#2E1919',
                text: shopName,
                fontSize: 26,
                textAlign: 'left',
                lineHeight: 26,
                fontFamily: 'DIN-Bold',
                letterSpacing: 0,
                fontWeight: 400,
                containerWidth: 340,
                id: 10,
                row: 1,
                width: 52,
                height: 26,
            },
            {
                drawType: 'text',
                x: 360,
                y: 362,
                zIndex: 10,
                color: '#2E1919',
                text: showName,
                fontSize: 26,
                textAlign: 'left',
                lineHeight: 26,
                fontFamily: 'DIN-Bold',
                letterSpacing: 0,
                fontWeight: 400,
                containerWidth: 340,
                id: 10,
                row: 1,
                width: 52,
                height: 26,
            },
            {
                drawType: 'text',
                x: 360,
                y: 546,
                zIndex: 10,
                color: '#2E1919',
                text: ticketInfoText,
                fontSize: 26,
                textAlign: 'left',
                lineHeight: 26,
                fontFamily: 'DIN-Bold',
                letterSpacing: 0,
                fontWeight: 400,
                containerWidth: 340,
                id: 10,
                row: 1,
                width: 52,
                height: 26,
            },
        ],
        lineArr: [],
        shapeArr: [],
        circleArr: [],
    };
}
exports.getDrawData = getDrawData;
